// extracted by mini-css-extract-plugin
module.exports = {"modal":"ingredient_modal__3gPcO"};